import React from 'react';
import FullScreenModal from 'components/static/FullScreenModal';
import {Spacer} from 'layout/util'
import {CloseIcon} from 'components/static/icons'
import styled from 'styled-components';
import Color from 'constants/colors'

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseIconStyle = styled.div`
  height: 22px;
  width: 22px;
  cursor: pointer;
`;

const MenuItem = styled.div`
  font-family: ${props=>props.theme.fonts.h4};
  color: ${Color('purple')};
  font-size: 12px;
  cursor: pointer;
`;

class PrivacyModal extends React.Component {
	  //-- to toggle visibility, pass as prop to give access to children
  toggleVisibility = (forceVisible) => {
    if(forceVisible === false) {
      this.props.onCancel();
    }
  }

  render() {
    const ExitButton = 
    <CloseIconStyle onClick={this.props.onCancel}>
      <CloseIcon />
    </CloseIconStyle>
  
		return(
	    <FullScreenModal 
	      overlayColor="rgba(0,0,0,0.5)"
	      onToggleVisibility={this.toggleVisibility}
	    >
        <Spacer height={10}/>
        <TitleWrapper>
          <h3>
            Change who can see this page
          </h3>
          {ExitButton}
        </TitleWrapper>
        <Spacer height={20}/>
	    	{this.props.children}
	    </FullScreenModal>
		);
  }
}




class PrivacyContent extends React.Component{
	constructor(props) {
		super(props);
		this.state = {
			showModal: false
		}
	}

  toggleFlagModal = (event) => {
    this.setState({
      showModal: !this.state.showModal
    });
  }

	render() {
    let modal = null;
    if (this.state.showModal) {
      modal = <PrivacyModal
      	{...this.props}
      	onCancel={this.toggleFlagModal}
      />;
    }

    const link = (
      <MenuItem onClick={this.toggleFlagModal}>
        {this.props.isShared ? 
          "This page is visible to anybody with the link" 
          : 
          "This page is only visible to you"
        }
      </MenuItem>
    );

		return(
	    <React.Fragment>
	      { modal }
	      { link }
	    </React.Fragment>
		)
	}
}

export default PrivacyContent;


// WEBPACK FOOTER //
// ./src/components/interactive/votePref/PrivacyModal.js